import { render } from "./receivePayments.vue?vue&type=template&id=2917a491&scoped=true"
import script from "./receivePayments.vue?vue&type=script&lang=js"
export * from "./receivePayments.vue?vue&type=script&lang=js"

import "./receivePayments.vue?vue&type=style&index=0&id=2917a491&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/rentalkenya_vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2917a491"]])

export default __exports__